/**
 * Module to add a shipping rates calculator to cart page.
 *
 * Copyright (c) 2011-2016 Caroline Schnapp (11heavens.com)
 * Dual licensed under the MIT and GPL licenses:
 * http://www.opensource.org/licenses/mit-license.php
 * http://www.gnu.org/licenses/gpl.html
 *
 */

// Adding utility function to Countries object defined in countries.js.
// Some countries use 'province' while others use 'state'.
if (typeof Countries === 'object') {

  function sortOptions(s) {
    var selected = s.val();
    var options = s.find('option');
    options.sort(function(a, b) {
      return a.text.localeCompare(b.text);
    })
    s.empty().append(options);
    s.val(selected);
  }

  Countries.updateCountryOptions = function(countryEl) {
    // translate options
    if (isLangifyFR) {
      var countryElOptions = countryEl.find('option');
      countryElOptions.each(function() {
        var e = $(this);
        var key = e.val();
        if (Countries[key] && Countries[key].country_label_fr) {
          e.text(Countries[key].country_label_fr);
        }
      });
      // now re-sort options alphabetically
      sortOptions(countryEl);
    }
  };

  Countries.updateProvinceLabel = function(country, provinceLabelElement) {
    if (typeof country === 'string' && Countries[country] && Countries[country].provinces) {
      if (typeof provinceLabelElement !== 'object') {
        provinceLabelElement = document.getElementById('address_province_label');
        if (provinceLabelElement === null) return;
      }
      provinceLabelElement.innerHTML = isLangifyFR ?
        Countries[country].label.replace("State", "État").replace("Region", "Région").replace("erritory", "erritoire").replace("Prefecture", "Préfecture").replace("County", "Comté").replace("Emirate", "Émirat").replace("Governorate", "Gouvernorat") :
        Countries[country].label;
    }
  };

  Countries.updateZipCodeLabel = function(country) {
    var el;
    if (typeof country === "string" && Countries[country]) {
      el = document.getElementById("address_zip_label");
      if (el !== null) {
        el.innerHTML = isLangifyFR ? "Code postal" : Countries[country].zip_label;
      }
      el = document.getElementById("address_zip");
      if (el !== null) {
        $(el).attr('placeholder', (isLangifyFR ? "Code postal" : Countries[country].zip_label));
      }
    }
  };

  // called only once on init to translate province names
  Countries.translateProvinceOptions = function(countryEl, provinceEl, provinceContainer) {
    if (isLangifyFR) {
      //translate options
      Countries.updateProvinceOptions(countryEl, provinceEl, provinceContainer);
    } else {
      $(provinceEl).prepend($('<option>', { value: '---', text: '---' }));
    }
    //set selected index
    var t = provinceEl.getAttribute("data-default");
    Shopify.setSelectorByValue(provinceEl, t);
  };

  // based on shopify_common countryHandler() function - added translation
  Countries.updateProvinceOptions = function(countryEl, provinceEl, provinceContainer) {
    var c = countryEl.options[countryEl.selectedIndex];
    var e = c.getAttribute("data-provinces");
    var n = JSON.parse(e);
    if (Shopify.CountryProvinceSelector.prototype.clearOptions(provinceEl), n && n.length == 0) {
      provinceContainer.style.display = "none";
    } else {
      $(provinceEl).append($('<option>', { value: '---', text: '---' }));
      for (var i = 0; i < n.length; i++) {
        var t = document.createElement("option");
        t.value = n[i][0];
        if (isLangifyFR && Countries[c.value] && Countries[c.value].province_labels_fr) {
          t.innerHTML = Countries[c.value].province_labels_fr[n[i][0]];
        } else {
          t.innerHTML = n[i][1];
        }
        provinceEl.appendChild(t);
      }
      sortOptions($(provinceEl));
      provinceContainer.style.display = "";
    }
  };

}

// Adding Shopify.Cart.ShippingCalculator object.
if (typeof Shopify.Cart === 'undefined') {
  Shopify.Cart = {}
}
// Creating a module to encapsulate this.
Shopify.Cart.ShippingCalculator = (function() {
  var _config = {
    submitButton: 'Calculate shipping',
    submitButtonDisabled: 'Calculating...',
    templateId: 'shipping-calculator-response-template',
    wrapperId: 'wrapper-response',
    customerIsLoggedIn: false,
    moneyFormat: '${{amount}}'
  };
  var _render = function(response) {
    var template = jQuery('#' + _config.templateId);
    var wrapper = jQuery('#' + _config.wrapperId);
    if (template.length && wrapper.length) {
      _.templateSettings = {
        evaluate: /<%([\s\S]+?)%>/g,
        interpolate: /<%=([\s\S]+?)%>/g,
        escape: /<%-([\s\S]+?)%>/g
      };
      var myTemplate = _.template(jQuery.trim(template.text()));
      var compiled = myTemplate(response);
      jQuery(compiled).appendTo(wrapper);
      if (typeof Currency !== 'undefined' && typeof Currency.convertAll === 'function') {
        var newCurrency = '';
        if (jQuery('[name=currencies]').size()) {
          newCurrency = jQuery('[name=currencies]').val();
        } else if (jQuery('#currencies span.selected').size()) {
          newCurrency = jQuery('#currencies span.selected').attr('data-currency');
        }
        if (newCurrency !== '') {
          Currency.convertAll(shopCurrency, newCurrency, '#wrapper-response span.money, #estimated-shipping span.money');
        }
      }
    }
  };
  var _enableButtons = function() {
    jQuery('.get-rates').removeAttr('disabled').removeClass('disabled').val(_config.submitButton);
  };
  var _disableButtons = function() {
    jQuery('.get-rates').val(_config.submitButtonDisabled).attr('disabled', 'disabled').addClass('disabled');
  };
  var _getCartShippingRatesForDestination = function(shippingAddress) {
    //console.log(this.$('.cart-item').length);
    var params = {
      type: 'POST',
      url: '/cart/prepare_shipping_rates',
      data: jQuery.param({ 'shipping_address': shippingAddress }),
      success: _pollForCartShippingRatesForDestination(shippingAddress),
      error: _onError
    }
    jQuery.ajax(params);
  };
  var _pollForCartShippingRatesForDestination = function(shippingAddress) {
    var poller = function() {
      jQuery.ajax('/cart/async_shipping_rates', {
        dataType: 'json',
        success: function(response, textStatus, xhr) {
          if (xhr.status === 200) {
            _onCartShippingRatesUpdate(response.shipping_rates, shippingAddress)
          } else {
            setTimeout(poller, 500)
          }
        },
        error: _onError
      })
    }
    return poller;
  };
  var _fullMessagesFromErrors = function(errors) {
    var fullMessages = [];
    jQuery.each(errors, function(attribute, messages) {
      jQuery.each(messages, function(index, message) {
        fullMessages.push(attribute + ' ' + message);
      });
    });
    return fullMessages;
  };
  var _onErrorOriginal = function(XMLHttpRequest, textStatus) {
    jQuery('#estimated-shipping').hide();
    jQuery('#estimated-shipping em').empty();
    // Re-enable calculate shipping buttons.
    _enableButtons();
    // Formatting error message.
    var feedback = '';
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
      feedback = data.message + '(' + data.status  + '): ' + data.description;
    } 
    else {
      feedback = 'Error : ' + _fullMessagesFromErrors(data).join('; ') + '.';
    }    
    if (feedback === 'Error : country is not supported.') feedback = 'We do not ship to this destination.';
    // Update calculator.
    _render( { rates: [], errorFeedback: feedback, success: false } );
    jQuery('#' + _config.wrapperId).show();
  };  
  var _onError = function(XMLHttpRequest, textStatus) {
    // Re-enable calculate shipping buttons.
    _enableButtons();
    // Formatting error message.
    var feedback = '';
    var data = eval('(' + XMLHttpRequest.responseText + ')');
    if (!!data.message) {
      feedback = data.message + '(' + data.status + '): ' + data.description;
    } else {
      feedback = 'Error : ' + _fullMessagesFromErrors(data).join('; ') + '.';
    }
    // translate error messages
    if (isLangifyFR) {
      if (feedback.indexOf("country is not supported") >= 0) { feedback = "Erreur: pays invalide."; }
      if (feedback.indexOf("zip is not valid") >= 0) { feedback = "Erreur: code postal invalide."; }
      if (feedback.indexOf("province is not a valid") >= 0) { feedback = "Erreur: province invalide."; }
      if (feedback.indexOf("zip can't be blank") >= 0) { feedback = "Erreur: vous devez fournir un code postal."; }
    }
    // Update calculator response
    $('.cart-shipping-calculator-response').html("<p>" + feedback + "</p>");
  };
  var _onCartShippingRatesUpdate = function(rates, shipping_address) {
    // Re-enable calculate shipping buttons.
    _enableButtons();
    // Formatting shipping address.
    var readable_address = '';
    if (shipping_address.zip) readable_address += shipping_address.zip + ', ';
    if (shipping_address.province) readable_address += $('#address_province option:selected').text() + ', ';
    readable_address += $('#address_country option:selected').text();
    // Show estimated shipping.
    var firstRate, ratesFeedback, responseText, shippingCalculatorResponse;
    shippingCalculatorResponse = $('.cart-shipping-calculator-response');
    shippingCalculatorResponse.empty().append("<p class='shipping-calculator-response message'/><ul class='shipping-rates'/>");
    ratesFeedback = $('.shipping-calculator-response');
    if (rates.length) {
      if (rates[0].price == '0.00') {
        return ratesFeedback.html(_config.freeRate);
      } else if (rates.length > 1) {
        firstRate = _formatRate(rates[0].price);
        responseText = _config.multiRates.replace('** address **', readable_address).replace('** number_of_rates **', rates.length).replace('** rate **', "<span class='money'>" + firstRate + "</span>");
        ratesFeedback.html(responseText);
      } else if (rates.length === 1) {
        responseText = _config.oneRate.replace('** address **', readable_address);
        ratesFeedback.html(responseText);
      }
    } else {
      return ratesFeedback.html(_config.noRates);
    }
    for (var j = 0; j < rates.length; j++) {
      var rate = rates[j];
      var price = _formatRate(rate.price);
      var rateValues = _config.rateValues.replace('** rate_title **', rate.name).replace('** rate **', "<span class='money'>" + price + "</span>");
      $('.shipping-rates').append("<li>" + rateValues + "</li>");
    }
  };
  var _onCartShippingRatesUpdateOriginal = function(rates, shipping_address) {
    // Re-enable calculate shipping buttons.
    _enableButtons();
    // Formatting shipping address.
    var readable_address = '';
    if (shipping_address.zip) readable_address += shipping_address.zip + ', ';
    if (shipping_address.province) readable_address += shipping_address.province + ', ';
    readable_address += shipping_address.country;
    // Show estimated shipping.
    if (rates.length) {
      if (rates[0].price == '0.00') {
        jQuery('#estimated-shipping em').html('FREE');
      } else {
        jQuery('#estimated-shipping em').html(_formatRate(rates[0].price));
      }
      for (var i = 0; i < rates.length; i++) {
        rates[i].price = _formatRate(rates[i].price);
      }
    }
    // Show rates and feedback.
    _render({ rates: rates, address: readable_address, success: true });
    // Revealing response.
    jQuery('#' + _config.wrapperId + ', #estimated-shipping').fadeIn();
  };
  var _formatRate = function(cents) {
    if (typeof Shopify.formatMoney === 'function') {
      return Shopify.formatMoney(cents, _config.moneyFormat);
    }
    if (typeof cents == 'string') { cents = cents.replace('.', ''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = _config.moneyFormat;

    function defaultOption(opt, def) {
      return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = defaultOption(precision, 2);
      thousands = defaultOption(thousands, ',');
      decimal = defaultOption(decimal, '.');
      if (isNaN(number) || number == null) { return 0; }
      number = (number / 100.0).toFixed(precision);
      var parts = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents = parts[1] ? (decimal + parts[1]) : '';
      return dollars + cents;
    }
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
    return formatString.replace(placeholderRegex, value);
  };
  _init = function() {
    // Initialize observer on shipping address.
    new Shopify.CountryProvinceSelector('address_country', 'address_province', { hideElement: 'address_province_container' });
    var countriesSelect = jQuery('#address_country');
    // remove Shopify_Common country event handler - using my own instead to implement translations!
    var selected = countriesSelect.val();
    countriesSelect[0].outerHTML = countriesSelect[0].outerHTML; // clears all event handlers on element
    countriesSelect.val(selected);
    // Updating province label.
    var addressProvinceEl = jQuery("#address_province").get(0);
    var addressProvinceLabelEl = jQuery('#address_province_label').get(0);
    if (typeof Countries !== 'undefined') {
      Countries.updateCountryOptions(countriesSelect);
      Countries.updateProvinceLabel(countriesSelect.val(), addressProvinceLabelEl);
      Countries.updateZipCodeLabel(countriesSelect.val());
      Countries.translateProvinceOptions(countriesSelect.get(0), addressProvinceEl, $("#address_province_container").get(0));
      countriesSelect.change(function() {
        Countries.updateProvinceOptions(countriesSelect.get(0), addressProvinceEl, $("#address_province_container").get(0)),
          Countries.updateProvinceLabel(countriesSelect.val(), addressProvinceLabelEl),
          Countries.updateZipCodeLabel(countriesSelect.val()),
          $('.cart-shipping-calculator-response').empty();    
      });
      jQuery("#address_province").change(function() {
        $('.cart-shipping-calculator-response').empty();    
      });
      jQuery("#address_zip").change(function() {
        $('.cart-shipping-calculator-response').empty();    
      });
    }
    // When either of the calculator buttons is clicked, get rates.
    jQuery('.get-rates').click(function() {
      // Disabling all buttons.
      _disableButtons();
      // Hiding response.
      jQuery('#' + _config.wrapperId).empty().hide();
      // Reading shipping address for submission.
      var shippingAddress = {};
      shippingAddress.zip = jQuery('#address_zip').val() || '';
      shippingAddress.country = jQuery('#address_country').val() || '';
      shippingAddress.province = jQuery('#address_province').val() || '';
      _getCartShippingRatesForDestination(shippingAddress);
    });
    // We don't wait for customer to click if we know his/her address.
    if (_config.customerIsLoggedIn) {
      jQuery('.get-rates:eq(0)').trigger('click');
    }
  };
  return {
    show: function(params) {
      // Configuration
      params = params || {};
      // Merging with defaults.
      jQuery.extend(_config, params);
      // Action
      jQuery(function() {
        _init();
      });
    },
    getConfig: function() {
      return _config;
    },
    formatRate: function(cents) {
      return _formatRate(cents);
    }
  }
})();